module.exports = __webpack_public_path__ + "static/img/3c75d46ae8685185bce31e5663ae5bed29fd76f1.e8a4c98a.png";